<template lang="pug">
    
    .preview-image
        a(v-if="path || href" :href="finalLink" :target="target")
          img(
              v-lazy="box.image"
              :title="box.data.title"
              :style="{ width: `${box.style.width}px`, height: `${box.style.height}px` }"
              rel="noopener"
          )
          caption(v-if="box.data.title || striptags(box.data.text)")
              h4 {{ box.data.title }}
              div( v-html="box.data.text" )
        a(v-else href="#" @click.prevent="$photoswipe.open($event, index, photoSwipeItems)")
          img(
              v-lazy="box.image"
              :title="box.data.title"
              :style="{ width: `${box.style.width}px`, height: `${box.style.height}px` }"
              rel="noopener"
          )
          caption(v-if="box.data.title || striptags(box.data.text)")
              h4 {{ box.data.title }}
              div( v-html="box.data.text" )

</template>

<script>
import { get, startsWith, trim } from '@/helpers';
import striptags from 'striptags';
export default {
    name: 'AlbumImage',
    data() {
        return {
            maxHeight: 500
        };
    },
    props: {
        box: {
            type: Object,
            required: true
        }
    },
    computed: {
        photoSwipeItems() {
            let items = [];
            if (this.box.data && this.box.image) {
                const src = this.box.image.src;
                const w = this.box.image.width;
                const h = this.box.image.height;

                let title = '';
                if (this.box.data.title) title += `<h4>${this.box.data.title}</h4>`;
                if (this.striptags(this.box.data.text)) title += this.box.data.text;

                items.push({ src, w, h, title });
            }

            return items;
        },

        hyperlink() {
            return get(this.box.data, 'hyperlink') || {};
        },
        href() {
            let href = false;

            if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href;
                switch (this.hyperlink.type) {
                    case 'external':
                        if (!startsWith(link, 'https://') && !startsWith(link, 'http://')) href = `https://${link}`;
                        else href = link;
                        break;

                    case 'mailto':
                        href = `mailto:${link}`;
                        break;

                    case 'tel':
                        href = `tel:${link}`;
                        break;
                }
            }

            return href;
        },
        target() {
            return get(this.hyperlink, 'target') || '_self';
        },
        path() {
            if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
                return this.hyperlink.menuItem.path;
            else return false;
        },

        finalLink() {
            if (this.path) {
                return this.path;
            } else if (this.href) {
                return this.href;
            } else {
                return false;
            }
        }
    },
    methods: {
        striptags(value) {
            return trim(striptags(value));
        }
    }
};
</script>

<style lang="sass" scoped></style>
